import { Column, Spinner } from "@hightouch/htui";

import { Paper } from "src/components/paper";

export const PaperLoader = () => {
  return (
    <Paper flex={1} minHeight={0}>
      <Column flex={1} minHeight={0} align="center" justify="center">
        <Spinner size="lg" />
      </Column>
    </Paper>
  );
};
